export default __webpack_public_path__ + "static/media/unity.cccd6e4e.png";